<template>
  <div class="accounts">
    <div class="user-column is-pulled-right">
      <div class="dropdown is-right is-hoverable">
        <div class="dropdown-trigger">
          <button class="button user-btn">
            <span>{{ displayName }} ({{ $t('common.sign_out') }})</span>
            <span class="icon is-small">
              <i class="fas fa-angle-down" />
            </span>
          </button>
        </div>
        <div class="dropdown-menu">
          <div class="dropdown-content">
            <a
              class="dropdown-item"
              @click.prevent="signOut"
            >
              {{ $t('common.sign_out') }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <center-panel>
      <div class="account-list-wrapper">
        <div>
          <img
            v-if="$store.state.logos.length"
            class="brand-logo image"
            :src="$store.state.logos[0]"
          >
          <img
            v-else
            src="../assets/dc-logo-web.com-black.png"
            class="web-logo image"
            alt="webdotcom"
          >
          <div class="is-size-3 accounts-header has-text-centered has-text-dark">
            {{ $t('accounts.choose_account') }}
          </div>
        </div>
        <nav class="scrollable-accounts">
          <div>
            <div v-if="$apollo.loading">
              <account-placeholder
                v-for="item in 4"
                :key="item"
              />
            </div>
            <spinner v-else-if="waiting" />
            <a
              v-for="account in accounts"
              v-else
              :key="account.accountId"
              class="panel-block account-list"
              @click.prevent="handleChangeAccount(account)"
            >
              <span class="panel-icon">
                <font-awesome-icon
                  icon="user-circle"
                  size="2x"
                />
              </span>
              {{ account.name }} {{ account.services.some(svc => svc.name === 'website') ? '(website)' : '' }}
            </a>
          </div>
        </nav>
        <div v-if="getTenantConfig('showPolicy')">
          <div class="panel-block panel-footer">
            <a
              :href="$t('modify_website.policy_url')"
              target="_blank"
            >
              {{ $t('modify_website.policy_link') }}
            </a>
          </div>
        </div>
      </div>
    </center-panel>
  </div>
</template>

<script>
import CenterPanel from '@/components/Shared/CenterPanel'
import { mapActions, mapGetters } from 'vuex'
// import GET_CUSTOMER from '@/graphql/GET_CUSTOMER.gql'
import GET_CUSTOMER_DETAILS from '@/graphql/GET_CUSTOMER_DETAILS.gql'
import AccountPlaceholder from '@/components/Shared/AccountPlaceholder'
import Spinner from '@/components/Shared/Spinner'
import tenantConfigMixin from '@/mixins/tenant-config'

export default {

  name: 'Accounts',
  components: {
    CenterPanel,
    AccountPlaceholder,
    Spinner
  },
  mixins: [
    tenantConfigMixin
  ],
  data () {
    return {
      accounts: [],
      waiting: false,
      customer: []
    }
  },
  apollo: {
    customer: {
      query: GET_CUSTOMER_DETAILS,
      variables () {
        return { customerId: this.customerId }
      },
      update: data => {
        return data.getCustomerDetails
      }
    }
  },
  computed: {
    ...mapGetters(['clientCredentials', 'username', 'customerId', 'displayName'])
  },
  watch: {
    accounts (acc, prevAcc) {
      const counter = acc.length
      this.setAccountCount(counter)
      if (counter <= 1) {
        this.handleChangeAccount(acc[0])
      }
    },
    customer () {
      this.setPreferredLanguage(this.customer.preferredLanguage)

        const manageableServices = ['scorecard', 'website', 'email', 'payPerClick', 'yolawebsite', 'sitepluswebsite', 'accountprofile', 'flockemail', 'totalchatbotswebchat']

      this.setDisplayName(this.customer.displayName)
      this.accounts = this.customer.accounts.filter(acct => {
        if (acct.status === 'ACTIVE' || acct.status === 'SUSPENDED') {
          // get a list of the services that this account has

          const accountServices = acct.services.map(function (svc) {
            // get the list of allowed services
            return svc.name
          })
          // return true if there are any manageable services on this account
          return accountServices.some(accountService => manageableServices.includes(accountService))
        }
      })
    }
  },
  mounted () {
    this.$store.state.showSliderBT = null
    this.$store.state.showGettingStarted = false
    this.$store.state.showSliderEcomm = null
  },
  methods: {
    ...mapActions(['handleSession', 'changeAccount', 'setPreferredLanguage', 'setAccountCount', 'setDisplayName', 'clearSessionData']),
    async signOut () {
      await this.$auth.signOut()
      this.clearSessionData()
      this.handleSession(null)
      this.$router.history.push('/')
    },
    handleChangeAccount (account) {
      this.waiting = true
      this.changeAccount(account)
      this.$router.push('/main')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/_variables.scss';
.user-btn {
  border: none;
  padding: 10px;
  z-index: 10;
  font-size: 14px;
  color: var(--base-grey-dark);
}
.dropdown-content {
  border-radius: 0px;

  .dropdown-item {
    font-size: 12px;
  }
}
.web-logo {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 35px;
  margin-top: 50px;
  max-width: 170px;
}
.brand-logo {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;
  margin-top: 20px;
  max-width: 140px;
}
.scrollable-accounts {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  flex: 1;
}

.accounts-header {
  padding-bottom: 25px;
}

.account-list-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 486px;
  background: white;
}

.account-list {
  padding: 6px 15px 6px 15px;
  border-left: none;
  border-right: none;
  height: 66px;
  color: var(--base-grey-medium);

  .panel-icon {
    padding: 6px 30px 34px 0px;
  }
}
.panel-footer {
  padding: 10px;
  border: none;
  a {
    margin-right: 5px;
    font-size: 12px;
  }
}

@media only screen and (max-width: 400px) {
  .account-list-wrapper {
    min-height: 100vh;
  }
}
</style>
